module.exports = __webpack_public_path__ + "img/ic-ads-account.ea94b0ad.svg";